import { dialogTypes } from '@/contexts/JDialogContext';
import { Dialog, Typography, styled } from '@mui/material';

interface JdialogStyledProps {
  type?: dialogTypes;
}

export const JdialogStyled = styled(Dialog)<JdialogStyledProps>(
  ({ theme, type = 'basic' }) => ({
    '& .MuiPaper-root': {
      padding: type === 'basic' ? theme.spacing(4) : 0,
      width: type === 'filter' ? '512px' : 'inherit',
      borderRadius: theme.spacing(1),
    },
  }),
);

export const JdialogTitleStyled = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));
export const JdialogFilterTitleStyled = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid',
  borderColor: theme.palette.dark.dark_5,
  padding: theme.spacing(1),
}));
